// Browser-safe wrapper around window.sessionStorage.
// Session-scoped: survives page refresh, cleared when the tab/browser closes.

type SessionStorageService = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
};

const getStorage = (): Storage | null => {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    // sessionStorage can throw in private mode or when disabled by the browser.
    return null;
  }
};

const sessionStorageService: SessionStorageService = {
  getItem: (key) => {
    try {
      return getStorage()?.getItem(key) ?? null;
    } catch {
      // Access blocked (private mode / disabled storage).
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      getStorage()?.setItem(key, value);
    } catch {
      // Write blocked (quota exceeded / disabled storage).
    }
  },
  removeItem: (key) => {
    try {
      getStorage()?.removeItem(key);
    } catch {
      // Removal blocked (disabled storage).
    }
  },
};

export { sessionStorageService };
